<template>
  <section :class="isMobile ? 'repair-step mobile-repair-step' : 'repair-step'">
    <div class="title">闭环措施（工艺）</div>
    <div class="form">
      <root-cause-analyses-vue
        :rootCauseAnalyses="problemForm.rootCauseAnalyses"
        ref="rootCauseAnalysesRef"
        :formdata="problemForm"
        :disabled="!isEdit"
        type="4"
        title="根本原因分析"
      >
      </root-cause-analyses-vue>

      <div class="form-item">
        <div class="df">
          <div class="step-label">附件</div>
          <upload-annex-vue
            ref="uploadannex"
            :attachment="problemForm.annex"
            :disabled="!isEdit"
          ></upload-annex-vue>
        </div>
      </div>

      <div class="form-item">
        <a-space
          :size="isMobile ? 20 : 10"
          :direction="isMobile ? 'vertical' : 'horizontal'"
        >
          <div class="df">
            <div class="step-label">完成时间</div>
            <div class="data">
              <select-day-vue
                :defaultVal="problemForm.completeDate"
                @userDelectDay="userDelectDay"
                :disabled="!isEdit"
              ></select-day-vue>
            </div>
          </div>
          <div class="df">
            <div class="step-label">经手人</div>
            <div class="data">
              <a-input
                v-model:value="problemForm.principal"
                placeholder="请输入经手人"
                :disabled="!isEdit"
                allow-clear
              ></a-input>
            </div>
          </div>
          <div class="df" v-if="problemForm.rollbackReason">
            <div class="step-label">回退原因</div>
            <div class="data">
              <a-input
                v-model:value="problemForm.rollbackReason"
                :disabled="true"
              ></a-input>
            </div>
          </div>
          <div class="df" v-if="problemForm.username">
            <div class="step-label">编辑人</div>
            <div class="data">
              {{ problemForm.username }}
            </div>
          </div>
        </a-space>
      </div>
    </div>

    <div class="footer df both-side">
      <a-button type="primary" :disabled="!isEdit" @click="saveInfo"
        >保存</a-button
      >
      <a-space :size="isMobile ? 10 : 50">
        <a-button @click="nextStep" :disabled="!isEdit">下一步</a-button>
        <a-button @click="backPreStep" :disabled="!isEdit" type="danger"
          >退回上一级</a-button
        >
      </a-space>
    </div>
  </section>

  <roll-back-modal-vue
    ref="rollBackModal"
    @rollBack="rollBack"
  ></roll-back-modal-vue>
</template>

<script>
import { defineComponent, reactive, watch, ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import {
  updateClosedLoop,
  closedLoopConfirm,
  closedLoopRollback,
  saveOrUpdateRootCauseAnalysis,
} from "@/request/view/repair";
import { Toast, showUploading, hideUploading } from "@/utils/index";
import { showModal } from "../serve/modal";
import selectDayVue from "./selectDay.vue";
import uploadImgVue from "./uploadImg.vue";
import uploadVideoVue from "./uploadVideo.vue";
import rollBackModalVue from "./rollBackModal.vue";
import rootCauseAnalysesVue from "./rootCauseAnalyses.vue";
import uploadAnnexVue from "./uploadAnnex.vue";

export default defineComponent({
  components: {
    uploadImgVue,
    uploadVideoVue,
    selectDayVue,
    rollBackModalVue,
    rootCauseAnalysesVue,
    uploadAnnexVue,
  },
  props: {
    progress: Object,
    machine: Object,
    meta: Object,
  },
  setup(props, context) {
    const router = useRouter();
    const back = () => {
      // router.replace("/repairequipment");
      context.emit("back");
    };
    const problemForm = reactive({
      annex: null,
      closedLoopRollbackReason: null,
      completeDate: null,
      id: null,
      isEditable: true,
      principal: null,
      repairEquipmentId: null,
      reviewRollbackReason: null,
      rootCauseAnalyses: null,
      type: null,
      userId: null,
      username: null,
    });

    const getEditLock = () => {
      const { id, username } = store.state.user.user;
      if (problemForm.userId === null && problemForm.username === null) {
        return true;
      } else if (problemForm.userId == id) {
        return true;
      }
      return false;
    };
    const store = useStore();
    const isMobile = computed(() => store.state.isMonile);
    const isEdit = computed(() => {
      if (store.getters.user) {
        const unlock = getEditLock();
        return (
          props.meta["/technologyupdateInfo"] &&
          machineInfo.repairProcess == 4 &&
          unlock
        );
      }
      return false;
    });
    const uploadImg = ref();
    const uploadVideo = ref();
    const rollBackModal = ref();
    const machineInfo = reactive({
      id: null,
      repairProcess: null,
    });
    const rootCauseAnalysesRef = ref();

    const uploadannex = ref();

    const saveInfo = async () => {
      showUploading("上传中");
      let annex = null;
      await uploadannex.value
        .uploadFile()
        .then((res) => {
          annex = JSON.stringify(res);
        })
        .catch((err) => {
          console.log(err);
          hideUploading();
        });

      // let rootCauseAnalyses = null;
      await rootCauseAnalysesRef.value
        .uploadContent()
        .then()
        .catch((err) => {
          console.log(err);
          hideUploading();
        });

      // await saveOrUpdateRootCauseAnalysis(rootCauseAnalyses)
      //   .then((res) => {
      //     console.log(res);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });

      updateClosedLoop({
        annex,
        completeDate: problemForm.completeDate,
        id: problemForm.id,
        isEditable: problemForm.isEditable,
        principal: problemForm.principal,
        repairEquipmentId: machineInfo.id,
        rollbackReason: problemForm.rollbackReason,
        userId: store.state.user.user.id,
        username: store.state.user.user.username,
        type: 4,
      })
        .then((res) => {
          context.emit("resetProcess");
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
          problemForm.id = res.data.id;
          hideUploading();
        })
        .catch((err) => {
          console.log(err);
          hideUploading();
        });
    };

    const nextStep = () => {
      showModal({
        title: "提示",
        toastText: "请先保存信息再确认到下一步流程？",
        success: () => {
          closedLoopConfirm({
            closedLoopId: problemForm.id,
          })
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200) {
                context.emit("updateMachineInfo");
                // context.emit("updateProcess", res.data);
                back();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const rollBack = (e) => {
      closedLoopRollback({
        closedLoopId: problemForm.id,
        rollbackReason: e,
      })
        .then((res) => {
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
          if (res.code === 200) {
            rollBackModal.value.handleCancel();
            context.emit("updateMachineInfo");
            back();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const backPreStep = () => {
      rollBackModal.value.showModal();
      rollBackModal.value.setInputData(problemForm.rollbackReason);
    };
    const userDelectDay = (day) => {
      problemForm.completeDate = day;
    };

    const setProblemData = (data) => {
      problemForm.annex = data.annex;
      problemForm.closedLoopRollbackReason = data.closedLoopRollbackReason;
      problemForm.completeDate = data.completeDate;
      problemForm.id = data.id;
      problemForm.isEditable = data.isEditable;
      problemForm.principal = data.principal;
      problemForm.repairEquipmentId = data.repairEquipmentId;
      problemForm.rollbackReason = data.closedLoopRollbackReason;
      problemForm.reviewRollbackReason = data.reviewRollbackReason;
      problemForm.rootCauseAnalyses = data.rootCauseAnalyses;
      problemForm.type = data.type;
      problemForm.userId = data.userId;
      problemForm.username = data.username;
    };
    watch(
      () => props.progress,
      () => {
        setProblemData(props.progress);
      },
      {
        immediate: true,
        deep: true,
      }
    );
    watch(
      () => props.machine,
      (val) => {
        machineInfo.id = val.id;
        machineInfo.repairProcess = null;
        machineInfo.repairProcess = val.repairProcess;
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      isMobile,
      problemForm,
      saveInfo,
      nextStep,
      backPreStep,
      userDelectDay,
      machineInfo,
      uploadImg,
      uploadVideo,
      rollBack,
      isEdit,
      rootCauseAnalysesRef,
      rollBackModal,
      uploadannex,
    };
  },
});
</script>

<style lang="less" scoped>
.margin-space {
  margin: 10px 0;
}
</style>
